import mergeRequestQueryVariablesMixin from '../../mixins/merge_request_query_variables';
import readyToMergeQuery from '../../queries/states/ready_to_merge.query.graphql';
import StatusIcon from '../mr_widget_status_icon.vue';
export default {
    name: 'ReadyToMerge',
    apollo: {
        canMerge: {
            query: readyToMergeQuery,
            skip () {
                return !this.mr;
            },
            variables () {
                return this.mergeRequestQueryVariables;
            },
            update: (data)=>data?.project?.mergeRequest?.userPermissions?.canMerge
        }
    },
    components: {
        StatusIcon
    },
    mixins: [
        mergeRequestQueryVariablesMixin
    ],
    props: {
        mr: {
            type: Object,
            required: true
        }
    },
    data () {
        return {
            canMerge: null
        };
    }
};
